export const DEFAULT_FLOWCODE_DESTINATION = 'https://flowcode.com/p/50JKXdahj'
export const DEFAULT_STUDIO_FLOWCODE_DESTINATION = 'https://flowcode.com/p/eiAZkKvIM'
